var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirthdaysIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1326_3436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50409 6.46201C10.6875 6.46201 11.6468 5.50232 11.6468 4.31854C11.6468 3.52963 10.6953 1.7579 10.0603 0.663623C9.81255 0.236475 9.1957 0.236475 8.94785 0.663623C8.313 1.7579 7.36139 3.52963 7.36139 4.31854C7.36139 5.50232 8.32073 6.46201 9.50409 6.46201Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6.46201C19.1834 6.46201 20.1427 5.50232 20.1427 4.31854C20.1427 3.52963 19.1912 1.7579 18.5562 0.663623C18.3085 0.236475 17.6916 0.236475 17.4438 0.663623C16.8089 1.7579 15.8573 3.52963 15.8573 4.31854C15.8573 5.50232 16.8166 6.46201 18 6.46201Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4959 6.46201C27.6792 6.46201 28.6386 5.50232 28.6386 4.31854C28.6386 3.52963 27.687 1.7579 27.0521 0.663623C26.8042 0.236475 26.1875 0.236475 25.9396 0.663623C25.3048 1.7579 24.3531 3.52963 24.3531 4.31854C24.3531 5.50232 25.3125 6.46201 26.4959 6.46201Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32437 8.22314C7.80026 8.22314 7.37537 8.64818 7.37537 9.1725V16.8312H11.6328V9.17257C11.6328 8.64825 11.208 8.22322 10.6838 8.22322H8.32437V8.22314Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8202 8.22314C16.2961 8.22314 15.8712 8.64818 15.8712 9.1725V16.8312H20.1286V9.17257C20.1286 8.64825 19.7037 8.22322 19.1796 8.22322H16.8202V8.22314Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3161 8.22314C24.792 8.22314 24.3671 8.64818 24.3671 9.1725V16.8312H28.6246V9.17257C28.6246 8.64825 28.1997 8.22322 27.6755 8.22322H25.3161V8.22314Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65823 25.038C4.82994 25.038 5.00565 25.0138 5.1803 24.9621L7.84276 24.1739C8.71301 23.9163 9.62054 23.7875 10.528 23.7875C11.4354 23.7875 12.343 23.9163 13.2132 24.1739L15.3147 24.7961C16.185 25.0537 17.0925 25.1825 18 25.1825C18.9074 25.1825 19.8149 25.0537 20.6852 24.7961L22.7867 24.1739C23.657 23.9163 24.5645 23.7875 25.4719 23.7875C26.3794 23.7875 27.2869 23.9163 28.1572 24.1739L30.8196 24.9621C30.9942 25.0138 31.1701 25.038 31.3417 25.038C32.1937 25.038 32.9439 24.4417 32.9439 23.6496V20.9305C32.9439 20.0291 32.0987 19.2983 31.0561 19.2983H4.94384C3.90125 19.2983 3.05609 20.0291 3.05609 20.9305V23.6496C3.05609 24.4417 3.80633 25.038 4.65823 25.038V25.038Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 33.5476H32.0663V27.0796C31.8293 27.124 31.5868 27.1474 31.3417 27.1474C30.9626 27.1474 30.5854 27.0927 30.2209 26.9848L27.5584 26.1966C26.8867 25.9978 26.1847 25.897 25.472 25.897C24.7592 25.897 24.0572 25.9978 23.3855 26.1966L21.284 26.8188C20.2233 27.1328 19.1185 27.292 18.0001 27.292C16.8817 27.292 15.7768 27.1328 14.7161 26.8188L12.6146 26.1966C11.9429 25.9978 11.2409 25.897 10.5281 25.897C9.81534 25.897 9.11334 25.9978 8.44165 26.1966L5.7792 26.9848C5.41455 27.0927 5.03747 27.1475 4.65834 27.1475C4.41316 27.1475 4.17073 27.1241 3.93377 27.0797V33.5477H1.05469C0.472219 33.5477 0 34.0199 0 34.6024C0 35.1848 0.472219 35.6571 1.05469 35.6571H34.9453C35.5278 35.6571 36 35.1848 36 34.6024C36 34.0199 35.5278 33.5476 34.9453 33.5476Z",
    fill: "#1BBDD4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1326_3436)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 6.5,
    fill: "#F06543"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1326_3436",
    x: 19,
    y: 19,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1326_3436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1326_3436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1326_3436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdaysIcon);
export default __webpack_public_path__ + "static/media/birthdays-icon.07c6357211218ae7e313ef9750c9a95c.svg";
export { ForwardRef as ReactComponent };